<template functional>
  <v-select
    :value="props.value"
    :items="props.values"
    v-bind="data.attrs"
    @input="listeners.input"
  />
</template>

<script>
export default {
  name: 'AgNumberSelect',
  props: {
    value: {
      type: Number,
      required: true,
    },
    values: {
      type: Array,
      required: true,
      validator (values) {
        return values.every(value => typeof value === 'number')
      },
    },
  },
}
</script>
